// extracted by mini-css-extract-plugin
module.exports = {"cards":"cuenta_cards__3Pw9j","container":"cuenta_container__2z_oe"};